import React from 'react';
import { formatCurrency } from '../../utils/invoiceFormatters';

const COMPONENTS = [
  { key: 'totalMakerCharge',   label: 'Maker',      sub: 'Per user per month',   color: '#378ADD' },
  { key: 'totalLoadingCharge', label: 'Loading',    sub: 'Loading charges',      color: '#1D9E75' },
  { key: 'totalAdminCharge',   label: 'Admin',      sub: 'Per admin per month',  color: '#7F77DD' },
  { key: 'totalUpiCharge',     label: 'UPI',        sub: 'Per UPI transaction',  color: '#EF9F27' },
  { key: 'totalAdditionalCharge', label: 'Additional', sub: 'Additional charges', color: '#D85A30' },
];

const ComponentBreakdownChart = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="space-y-4">
        {COMPONENTS.map((_, i) => (
          <div key={i} className="flex items-center gap-3">
            <div className="h-3 bg-gray-200 rounded animate-pulse w-16" />
            <div className="h-4 bg-gray-200 rounded animate-pulse flex-1" />
            <div className="h-3 bg-gray-200 rounded animate-pulse w-12" />
          </div>
        ))}
      </div>
    );
  }

  const total = COMPONENTS.reduce((sum, c) => sum + Number(data?.[c.key] ?? 0), 0);

  return (
    <div className="space-y-3">
      {COMPONENTS.map((comp) => {
        const value = Number(data?.[comp.key] ?? 0);
        const pct = total > 0 ? ((value / total) * 100).toFixed(1) : 0;
        return (
          <div key={comp.key} className="flex items-center gap-3">
            <div className="w-20 shrink-0">
              <p className="text-xs font-semibold text-gray-700">{comp.label}</p>
              <p className="text-xs text-gray-400 truncate">{formatCurrency(value)}</p>
            </div>
            <div className="flex-1 bg-gray-100 rounded-full h-3 overflow-hidden">
              <div
                className="h-full rounded-full transition-all duration-500"
                style={{ width: `${pct}%`, backgroundColor: comp.color, minWidth: value > 0 ? '4px' : '0' }}
              />
            </div>
            <span className="text-xs text-gray-500 w-10 text-right">{pct}%</span>
          </div>
        );
      })}
    </div>
  );
};

export default ComponentBreakdownChart;
